import { makeStyles } from '@mui/styles'
import { MyAccountTheme, MyAccountPriceInputClasses } from '@dxp-module/themes'

const priceInputStyles = makeStyles<
  MyAccountTheme,
  Record<string, never>,
  MyAccountPriceInputClasses
>(
  theme => ({
    root: {
      marginRight: 15,
      padding: 0,
      '& fieldset': {
        top: 0,
        borderRadius: 0,
      },
      '& legend': {
        display: 'none',
      },
    },
    textField: {
      width: '100%',
    },
    input: {
      textAlign: 'left',
      paddingLeft: 5,
    },
    inputRoot: {
      paddingLeft: 14,
      height: 51,
    },
    inputFocused: {},
    label: {
      marginBottom: 4,
      color: theme.palette.common.black,
    },
    helper: {
      color: theme.palette.error.main,
      overflowX: 'hidden',
    },
    error: {
      transitionDuration: '.1s',
    },
    disabled: {
      backgroundColor: theme.palette.grey[100],
    },
    asterisk: {},
    errorWrapper: {},
  }),
  { name: 'MyAccount_PriceInput' }
)

export default priceInputStyles
